module.exports = "/_next/static/images/knowledge-030ac93cb560be4fb328cf5f7756f448.png";